import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconFiltersOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M12.004 18a4 4 0 0 1 3.874 3H27a1 1 0 1 1 0 2H15.878a4.002 4.002 0 0 1-7.748 0H5a1 1 0 1 1 0-2h3.13c.444-1.725 2.01-3 3.874-3m0 2A2 2 0 1 0 14 22.038V22l.001-.04A2 2 0 0 0 12.004 20m8-14a4 4 0 0 1 3.874 3H27a1 1 0 1 1 0 2h-3.122a4.002 4.002 0 0 1-7.748 0H5a1 1 0 1 1 0-2h11.13c.444-1.725 2.01-3 3.874-3m0 2A2 2 0 1 0 22 10.038V10l.001-.04A2 2 0 0 0 20.004 8" /></svg>;
export default SvgIconFiltersOutlined;